export const tagList = [
  {
    id: 0, label: 'Todos', value: 'all', checked: true,
  },
  {
    id: 3, label: 'Melhores avaliados', value: 'rating', checked: false,
  },
];
